/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import store from '../store/index';
import VueRouter from "vue-router";
// import Home from "../views/Home.vue";

Vue.use(Vuex);
Vue.use(VueRouter);

function guard(to, from, next){
  if(store.state.auth.loggedIn) {
    if(to.name === 'Login') {
        next('/home');
    } else {
      next(); // allow to enter route
    }
  } else{
      if(to.name !== 'Login') {
          next('/login');
      } else {
        next(); // allow to enter route
      }
  }
}

const routes = [
  {
		path: '*',
		meta: {
			pageTitle: 'No Component Found'
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/noComponentFound.vue")
	},
  {
    path: "/",
    redirect: to => {
      return '/login';
    }
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      pageTitle: 'Login',
      public: true,
		},
    // beforeEnter: guard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Login.vue")
  },
  {
    path: "/forget-password",
    name: "ForgetPassword",
    meta: {
      pageTitle: 'Forget Password',
      public: true,
		},
    // beforeEnter: guard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "ForgetPassword" */ "../views/forget-password.vue")
  },
  {
    path: "/password/reset",
    name: "password.reset",
    meta: {
      pageTitle: 'Reset Password',
      public: true,
		},
    // beforeEnter: guard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "ForgetPassword" */ "../views/reset-password.vue")
  },
  {
    path: "/home",
    name: "Home",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Home',
      public: false,
		},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/dashboard/dashboard_index.vue")
  },
  {
    path: "/profile-settings",
    name: "Profile.Settings",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Profile Settings',
      public: false,
		},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/profile-settings/user")
  },

  // Packages
  {
    path: "/packages",
    name: "packages",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Packages',
      public: false,
		},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "packages" */ "../views/packages/package_index.vue")
  },
  {
    path: "/packages/create",
    name: "packages.create",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Add Package',
      public: false,
		},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "packages.create" */ "../views/packages/create.vue")
  },
  {
    path: "/packages/edit/:package_id",
    name: "packages.edit",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Edit Packages',
      public: false,
		},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "packages.edit" */ "../views/packages/edit.vue")
  },
  {
    path: "/packages/:package_id",
    name: "packages.show",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Package Details',
      public: false,
		},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "packages.show" */ "../views/packages/show.vue")
  },
  {
    path: "/package-form/:package_id",
    name: "package.payment.form",
    meta: {
      pageTitle: 'Package Payment Form',
      public: true,
		},
    // beforeEnter: guard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "package.payment.form" */ "../views/packages/no-secure-form/index-pack-form")
  },
  // Payment Terminal
  // {
  //   path: "/payment-terminal",
  //   name: "payment.terminal",
  //   // beforeEnter: guard,
  //   meta: {
  //     pageTitle: 'Payment Terminal',
  //     public: false,
	// 	},
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "payment.terminal" */ "../views/payment-terminal/payment_terminal_index.vue")
  // },
  // {
  //   path: "/payment-terminal/create",
  //   name: "payment.terminal.create",
  //   // beforeEnter: guard,
  //   meta: {
  //     pageTitle: 'Create Payment',
  //     public: false,
	// 	},
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "payment.terminal.create" */ "../views/payment-terminal/create.vue")
  // },

  {
    path: "/payments",
    name: "payments",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Payments',
      public: false,
		},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "payments" */ "../views/payments/payments_index")
  },
  {
    path: "/old-payments",
    name: "old.payments",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Old Payments',
      public: false,
		},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "old.payments" */ "../views/old-payments/payments_index")
  },

  {
    path: "/old-payments-importer",
    name: "old.payments.importer",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Old Payments Importer',
      public: false,
		},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "old.payments" */ "../views/old-payments/old-payment-importer")
  },

  {
    name: "old.payments.edit",
    path: "/old-payments/edit/:payment_id",
    // beforeEnter: guard,
    meta: {
      pageTitle: 'Old Payments Edit',
      public: false,
		},
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "old.payments.edit" */ "../views/old-payments/edit")
  },

  // Invoices start
  {
    name: 'projects.main.invoice',
    path: '/invoices',
    meta: {
      pageTitle: 'Invoices',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "projects.main.invoice" */ "../views/invoices/invoice_index"),
  },
  {
    name: 'projects.main.invoice.create',
    path: '/invoices/create-invoice',
    meta: {
      pageTitle: 'Create Invoices',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "projects.main.invoice.create" */ "../views/invoices/create-invoice"),
  },
  {
    name: 'projects.manual.invoice.create',
    path: '/invoices/create-manual-invoice',
    meta: {
      pageTitle: 'Create Manual Invoices',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "projects.manual.invoice.create" */ "../views/invoices/create-manual-invoice"),
  },
  {
    name: 'projects.main.invoice.edit',
    path: '/invoices/edit-invoice/:invoice_id',
    meta: {
      pageTitle: 'Edit Invoices',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "projects.main.invoice.edit" */ "../views/invoices/edit-invoice"),
  },
  {
    name: 'projects.invoice.projectinvoicedetails',
    path: '/invoices/show/:invoice_id',
    meta: {
      pageTitle: 'Project Invoice - Details',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "invoice.invoicedetails" */ "../views/invoices/showinvoice"),
  },
  {
    name: 'projects.invoice.invoicedetails',
    path: '/projects/show/:project_id/invoices/show/:invoice_id',
    meta: {
      pageTitle: 'Project Invoice - Details',
      public: false,
    },
    component: () =>
    import(/* webpackChunkName: "invoice.invoicedetails" */ "../views/invoices/showinvoice"),
  },


  // invoices End
  // Start Non Secure Pages
  {
    path: "/pay-on-workbench/:invoice_id",
    name: "custom.invoice.payment.form",
    meta: {
      pageTitle: 'Pay on Workbench',
      public: true,
		},
    // beforeEnter: guard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "custom.invoice.payment.form" */ "../views/invoices/non-secure-for-client/index")
  },
  // {
  //   path: "/customize-package-form/:package_id",
  //   name: "custom.package.payment.form",
  //   meta: {
  //     pageTitle: 'Custom Package Payment Form',
  //     public: true,
	// 	},
  //   // beforeEnter: guard,
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "custom.package.payment.form" */ "../views/payment-terminal/no-secure-form/index-pack-form")
  // },
  {
    path: "/thank-you-page",
    name: "Package Form",
    meta: {
      pageTitle: 'Thank You',
      public: true,
		},
    // beforeEnter: guard,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/thank-you-page/thank-you-page")
  },

];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
